<template>
  <div>
    <ith-detail-skeleton v-show="!show" />
    <div v-if="show" class="asside">
      <figure class="show-img">
        <img
          v-if="show.imageUrl != null"
          class="image"
          :src="show.imageUrl"
          :alt="show.title"
        />
        <img v-else class="show-no-img" src="/img/no_image.png" />
      </figure>
      <div class="detail">
        <span class="title">Rating</span>
        <span class="item item-rating">
          <!-- <span> <font-awesome-icon color="#ffffff" icon="heart"/></span>
          <span>{{ show.likes | likes }}</span> -->

          <span class="rating" v-if="show.rating"> {{ show.rating }} </span>
          <span>
            <font-awesome-icon class="form--icon" color="#F3C033" icon="star" />
          </span>

          <span class="icon-imdb-container">
            <img class="icon--imdb" src="../../assets/imdb.png" alt="IMDB icon"
          /></span>
          <span>{{ show.imdbRating }}</span>
        </span>
        <span class="title">Genres</span>
        <div class="item">
          <span v-for="g in show.genres" :key="g" class="detail--chip"
            >{{ g }}
          </span>
        </div>
        <span class="title">Runtime</span>
        <span class="item" v-if="show.isMovie">
          {{ show.duration }} minutes
        </span>
        <span class="item" v-else-if="show.duration == 1">
          {{ show.duration }} season
        </span>
        <span class="item" v-else> {{ show.duration }} seasons </span>

        <span class="title">Language</span>
        <div class="item">
          <span v-for="l in show.languages" :key="l" class="detail--chip"
            >{{ l }}
          </span>
        </div>
        <span class="title">Director</span>
        <span class="item">{{ show.director }}</span>

        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from "vuex";

export default {
  computed: mapState(["show"]),
};
</script>

<style scoped>
.asside {
  display: grid;
  grid-template-columns: 1fr;
  /* justify-items: center; */
}

.show-img {
  margin-left: 2.5%;
  border-radius: 10px;
  width: 95%;
  /* height: 465px; */
  object-fit: cover;
}

.image {
  border-radius: 15px;
  width: 95%;
  justify-self: center;
}

.show-no-img {
  background-color: #d5d5d5;
  padding: 130px 25%;
  border-radius: 10px;
  width: 50%;
  object-fit: contain;
}

.detail {
  padding: 20px 2.5% 20px 4%;
  font-size: 0.8rem;
  display: grid;
  grid-template-columns: 30% 60%;
  justify-content: center;
  align-items: center;
  column-gap: 5%;
  row-gap: 12px;
  grid-template-areas: "title item";
}

.title {
  grid-area: "title";
  margin: 0px;
  padding: 0px;
}

.item {
  grid-area: "item";
  margin: 2px 5px;
  padding-top: 0px;
}

.item-rating {
  display: grid;
  grid-template-columns: 15px 1fr 40px 1fr;
  align-items: start;
  column-gap: 1px;
}
.detail--chip {
  margin-right: 3px;
  margin-top: 2px;
  font-size: 0.7rem;
  border: 1px solid white;
  border-radius: 5px;
  padding: 2px 7px;
  float: left;
}
.icon-imdb-container {
  margin-left: 10px;
}
.icon--imdb {
  width: 27px;
}
.form--icon {
  margin-left: 10px;
}

@media (min-width: 1264px) and (max-width: 1400px) {
}
@media (min-width: 1020px) and (max-width: 1264px) {
}
@media (min-width: 960px) and (max-width: 1020px) {
}
@media (min-width: 600px) and (max-width: 960px) {
}
@media (max-width: 600px) {
  .asside {
    padding-top: 70px;
  }
}
</style>
